import _defineProperty from "/mnt/c/Users/Alexandre/Desktop/workspace/redux-datatable/doc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
export default function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _extends({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}